import React, { FunctionComponent, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RootState } from '../../../redux/reducers/index'
import {
    AddMoreProducts,
    CartTotalSummaryContainer,
    CheckoutContainer,
    CartPaymentButton,
    CartTotalSummaryBody,
    CartTotalSummaryDetail,
    CartSummaryModalMobile,
    CartTotalSummaryTitle,
    ContainerOneStep,
    CartTotalSummaryTitleContainer
} from "../style";
import { Close } from "../../MainModal/Close";
import CurrencyFormat from '../../../utils/currencyFormat'
import { setFooterBottomSpacing } from "../../../redux/actions";
import { language } from "../../../utils/language";

type CartTotalSummaryOneProps = {
    data: any[],
    publicKey: string,
    clientId: number,
    totalAmount: number,
    shippingAmount: number,
    taxAmountTotal: number,
    consumptionTaxAmountTotal: number,
    cartId: string,
    color: string,
    isValidForm: boolean,
    nextStep?: () => any,
    getFormValues?: () => any,
    activeStep: number,
};

const CartTotalSummary: FunctionComponent<CartTotalSummaryOneProps> = ({ cartId, data, clientId, color, totalAmount, shippingAmount, taxAmountTotal, consumptionTaxAmountTotal, activeStep, nextStep = () => { }, isValidForm = false, getFormValues = () => { } }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    const [showDetailOnMobile, setShowDetailOnMobile] = useState(false);
    const [subTotalAmount, setSubTotalAmount] = useState(0);
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
    const [productHasProvider, setProductHasProvider] = useState(false);
    const [items, setItems] = useState<any>([])

    useEffect(() => {
        const productsRefs= data.filter((item: any) => item.references && item.references.length > 0)
        const productsData = data.filter((item: any) => !(item.references && item.references.length > 0))
        if (productsRefs.length > 0) {
            productsRefs.map((product: any) => {
                product.references.map((itemRef: any) => {
                    itemRef.data = product.productData.references.find( (field: any) => field.id === itemRef.id)
                    productsData.push({...product, references: [itemRef]})
                })    
            })
        }
        setItems(productsData)

    }, [data])

    useEffect(() => {
        dispatch(setFooterBottomSpacing('3.5rem'))
        return () => {
            dispatch(setFooterBottomSpacing(undefined))
        }
    }, [])

    useEffect(() => {
        const subTotal = items.map((cartProduct: any) => {
            let quantity = cartProduct.quantity
            let price = cartProduct.productData.netAmount !== 0 && cartProduct.productData.discountPrice !== 0 ? cartProduct.productData.discountPrice : cartProduct.productData.amount
            if (cartProduct.references && cartProduct.references.length) {
                price = cartProduct.references[0].data.netAmount !== 0 && cartProduct.references[0].data.discountPrice !== 0 ? cartProduct.references[0].data.discountPrice : cartProduct.references[0].data.amount
                quantity = cartProduct.references[0].quantity
            }
            return (quantity * price)

        })?.reduce((acc: any, next: any) => (acc + next), 0);
        
        const totalDiscount = items.map((cartProduct: any) => {
            let quantity = cartProduct.quantity
            let discount = cartProduct.productData.netAmount !== 0 && cartProduct.productData.discountPrice !== 0 ? cartProduct.productData.netAmount - cartProduct.productData.discountPrice : 0
            if (cartProduct.references && cartProduct.references.length) {
                discount = cartProduct.references[0].data.netAmount !== 0 && cartProduct.references[0].data.discountPrice !== 0 ? cartProduct.references[0].data.netAmount - cartProduct.references[0].data.discountPrice : 0
                quantity = cartProduct.references[0].quantity
            }
            return (quantity * discount)

        })?.reduce((acc: any, next: any) => (acc + next), 0);

        if (totalDiscount && subTotal) {
            setTotalDiscountAmount(totalDiscount);
        }
        setSubTotalAmount(subTotal);
    }, [items])
        
    useEffect(() => {
        if((data.filter((product: any) => product.productData.epaycoDeliveryProvider === true)).length > 0) {
            setProductHasProvider(true) 
        } else {
            setProductHasProvider(false) 
        }
    }, [data])

    const handleShowDetails = () => {
        setShowDetailOnMobile((prev) => !prev);
    };

    const handlePay = (event: React.SyntheticEvent) => {
        event.preventDefault();
    }

    const handleNextStep = async () => {
      nextStep()
    }

    return (
        <CartTotalSummaryContainer style={{display: !showDetailOnMobile ? 'none' : 'flex'}}>
            <CartTotalSummaryBody>
              <ContainerOneStep className={`${activeStep  === 0 ? "is-on-step-one" : ""}`}>
                    <CartSummaryModalMobile show={showDetailOnMobile}>
                        <CartTotalSummaryTitleContainer>
                            <CartTotalSummaryTitle>
                                {language[homeState.default_language]["summary"]}
                            </CartTotalSummaryTitle>
                        </CartTotalSummaryTitleContainer>
                        <CartTotalSummaryDetail style={{marginBottom: '8rem'}}>
                            <div style={{ fontSize: '16px'}}>
                                <div>{language[homeState.default_language]["subtotal"]}</div>
                                <div>
                                    <CurrencyFormat amount={Math.abs(subTotalAmount)} />
                                </div>
                            </div>
                            {
                                (taxAmountTotal + consumptionTaxAmountTotal) !== 0 &&
                                <div>
                                    <div>{language[homeState.default_language]["tax"]}</div>
                                    <div>
                                        <CurrencyFormat amount={Math.abs(taxAmountTotal + consumptionTaxAmountTotal)} />
                                    </div>
                                </div>
                            }
                            {
                                (taxAmountTotal+consumptionTaxAmountTotal) !== 0 && <div style={{ fontSize: '16px'}}>
                                    <div>{language[homeState.default_language]["subtotal"]} + {language[homeState.default_language]["tax2"]}</div>
                                    <div>
                                        <CurrencyFormat amount={Math.abs(subTotalAmount+taxAmountTotal+consumptionTaxAmountTotal)} />
                                    </div>
                                </div>
                            }
                            <div style={{ fontSize: '12px', color: '#5C5B5C', marginTop: '0'}}>
                              {language[homeState.default_language]["codeMessage"]}
                            </div>
                        </CartTotalSummaryDetail>
                    </CartSummaryModalMobile>
                  </ContainerOneStep>
            </CartTotalSummaryBody>
        </CartTotalSummaryContainer>
    );
};


export default CartTotalSummary;
